import axios from "../common";

export const ApiLogOut = async () => {
    return axios.get("/auth/logout", {withCredentials: true})
}